export default {
  admin_add_cad_user_swal_required_title: "Campos obrigatórios",
  admin_add_cad_user_swal_required_text_name_email: "Preencha Nome e E-mail para continuar.",
  admin_add_cad_user_swal_required_text_phone: "Preencha o Telefone para continuar.",
  admin_add_cad_user_swal_required_cnpj_title: "CNPJ obrigatório",
  admin_add_cad_user_swal_required_cnpj_text: "Para criar um cliente é necessário informar o CNPJ.",
  admin_add_cad_user_swal_success_client_title: "Cliente criado!",
  admin_add_cad_user_swal_success_client_text: "O cliente foi cadastrado com sucesso",
  admin_add_cad_user_swal_success_employee_title: "Funcionário cadastrado!",
  admin_add_cad_user_swal_success_employee_text: "O funcionário foi cadastrado com sucesso.",
  admin_add_cad_user_swal_error_title: "Erro",
  admin_add_cad_user_swal_error_text: "Não foi possível criar o usuário. Tente novamente.",
  admin_add_cad_user_title: "Criar usuário",
  admin_add_cad_user_label_name: "Nome:",
  admin_add_cad_user_placeholder_name: "Maria Silva",
  admin_add_cad_user_label_email: "E-mail:",
  admin_add_cad_user_placeholder_email: "email@empresa.com",
  admin_add_cad_user_label_profile: "Perfil:",
  admin_add_cad_user_option_client: "Cliente",
  admin_add_cad_user_option_technician: "Técnico",
  admin_add_cad_user_option_admin: "Comercial",
  admin_add_cad_user_label_company: "Nome da empresa:",
  admin_add_cad_user_placeholder_company: "Empresa XYZ",
  admin_add_cad_user_label_cnpj: "CNPJ:",
  admin_add_cad_user_placeholder_cnpj: "00.000.000/0000-00",
  admin_add_cad_user_label_phone: "Telefone:",
  admin_add_cad_user_placeholder_phone: "(11) 90000-0000",
  admin_add_cad_user_btn_create: "Criar",
  admin_add_cad_user_notify_text_1: "Seu cliente será notificado via e‑mail e via WhatsApp com um link de acesso.",
  admin_add_cad_user_notify_text_2: "Durante a versão teste, qualquer usuário cadastrado terá a senha padrão \"123456\".",
  admin_add_equip_swal_attention_title: "Atenção",
  admin_add_equip_swal_remove_warning_text: "Esse equipamento será removido ao salvar.",
  admin_add_equip_swal_error_title: "Erro",
  admin_add_equip_swal_invalid_service_text: "Selecione um serviço válido.",
  admin_add_equip_swal_success_title: "Sucesso",
  admin_add_equip_swal_save_success_text: "Equipamento salvo!",
  admin_add_equip_swal_save_first_text: "Salve o equipamento primeiro.",
  admin_add_equip_swal_remove_photo_title: "Remover foto?",
  admin_add_equip_swal_remove_photo_success_text: "Foto removida!",
  admin_add_equip_prompt_laudo_name: "Nome do laudo:",
  admin_add_equip_swal_remove_laudo_title: "Remover laudo?",
  admin_add_equip_swal_remove_laudo_success_text: "Laudo removido.",
  admin_add_equip_label_service: "Serviço vinculado",
  admin_add_equip_label_brand: "Marca",
  admin_add_equip_label_model: "Modelo",
  admin_add_equip_label_series: "Série",
  admin_add_equip_label_ca: "CA",
  admin_add_equip_label_obs_tech: "Observação Técnica",
  admin_add_equip_label_location: "Localização",
  admin_add_equip_label_next_revision: "Próxima Revisão",
  admin_add_equip_label_last_revision: "Última Revisão",
  admin_add_equip_label_active: "Ativo",
  admin_add_equip_btn_back: "Voltar",
  admin_add_equip_btn_save: "Salvar",
  admin_add_equip_btn_add_photo_before: "Adicionar Foto Antes",
  admin_add_equip_btn_add_photo_after: "Adicionar Foto Depois",
  admin_add_equip_btn_send_laudo: "Enviar Laudo (PDF)",
  admin_add_equip_btn_close: "Fechar",
  admin_add_equip_card_title_data: "📌 Dados do Equipamento",
  admin_add_equip_card_title_photos: "📷 Fotos",
  admin_add_equip_card_title_laudos: "📑 Laudos",
  admin_details_error_no_quotation: "Nenhuma cotação selecionada",
  admin_details_error_loading_details: "Erro ao carregar detalhes. Usando dados de demonstração.",
  admin_details_not_informed_company: "Empresa não informada",
  admin_details_not_informed_client: "Cliente não informado",
  admin_details_not_informed_address: "Endereço não informado",
  admin_details_not_specified_service: "Serviço não especificado",
  admin_details_no_observations: "Sem observações",
  admin_details_status_received_analysis: "Equipamento recebido e em análise.",
  admin_details_swal_confirm_receive_title: "Confirmar recebimento?",
  admin_details_swal_confirm_receive_text: "Isso sinaliza o cliente do recebimento e indica que o equipamento será analisado.",
  admin_details_swal_confirm_button: "Sim, confirmar",
  admin_details_swal_cancel_button: "Cancelar",
  admin_details_swal_success_title: "Sucesso",
  admin_details_swal_update_success_text: "Estimativa atualizada para 'estimativa entregue'.",
  admin_details_swal_error_title: "Erro",
  admin_details_swal_update_error_text: "Não foi possível atualizar a estimativa.",
  admin_details_loading_text: "Carregando detalhes...",
  admin_details_card_title_client: "📌 DADOS DO CLIENTE",
  admin_details_card_title_estimate: "📋 DADOS DA ESTIMATIVA",
  admin_details_card_title_budget: "💰 DADOS DO ORÇAMENTO",
  admin_details_no_data_available: "Nenhum dado disponível para exibição.",
  admin_equip_details_error_id_not_found: "ID do equipamento não encontrado",
  admin_equip_details_loading_text: "Carregando...",
  admin_equip_details_error_not_found: "Equipamento não encontrado",
  admin_equip_details_title_item_data: "Dados do Item",
  admin_equip_details_title_latest_photos: "Últimas Fotos do Equipamento",
  admin_equip_details_title_revision_history: "Histórico de Revisões",
  admin_equipaments_title_my_equipments: "Meus Equipamentos",
  admin_equipaments_btn_add_equipment: "Adicionar Equipamento",
  admin_estimate_respond_swal_attention_title: "Atenção",
  admin_estimate_respond_swal_no_items_text: "Adicione pelo menos um item à resposta",
  admin_estimate_respond_swal_success_title: "Sucesso",
  admin_estimate_respond_swal_sent_text: "Resposta enviada!",
  admin_estimate_respond_swal_error_title: "Erro",
  admin_estimate_respond_swal_error_text: "Não foi possível enviar a resposta",
  admin_estimate_respond_created_by_admin: "criado por: Comercial",
  admin_estimate_respond_card_title_client: "📌 DADOS DO CLIENTE",
  admin_estimate_respond_card_title_estimate: "📋 DADOS DA ESTIMATIVA",
  admin_estimate_respond_card_title_admin_response: "✍️ RESPOSTA DO COMERCIAL",
  admin_home_error_loading_details: "Erro ao carregar dados. Usando dados de demonstração.",
  admin_home_swal_search_title: "Buscar Equipamento",
  admin_home_swal_search_label: "Digite o ID do equipamento:",
  admin_home_swal_search_btn_confirm: "Buscar",
  admin_home_swal_search_btn_cancel: "Cancelar",
  admin_home_swal_found_title: "Equipamento Encontrado",
  admin_home_swal_not_found_title: "Equipamento não localizado",
  admin_home_card_label_waiting_estimate: "Aguardando\nEstimativa",
  admin_home_card_label_estimate_delivered: "Estimativa\nEntregue",
  admin_home_card_label_waiting_equipment: "Aguardando\nEquipamento",
  admin_home_card_label_equipment_analysis: "Equipamento\nEm Análise",
  admin_home_card_label_waiting_budget: "Aguardando\nOrçamento",
  admin_home_card_label_pending_approval: "Pendente de\nAprovação",
  admin_home_card_label_approved_maintenance: "Aprovado para\nManutenção",
  admin_home_card_label_waiting_inspection: "Aguardando\nInspeção e Laudo",
  admin_home_card_label_waiting_nf: "Aguardando\nFaturamento",
  admin_home_card_label_ready_pickup: "Pronto para\nRetirada",
  admin_home_loading_text: "Carregando dados...",
  admin_home_status_desc_waiting_estimate: "O cliente solicitou uma estimativa.",
  admin_home_status_desc_estimate_delivered: "A estimativa foi respondida, o cliente deve receber em breve.",
  admin_home_status_desc_waiting_equipment: "O cliente aceitou a estimativa, e estamos aguardando o envio do equipamento.",
  admin_home_status_desc_equipment_analysis: "O equipamento chegou e está em análise/cadastro.",
  admin_home_status_desc_waiting_budget: "O apontamento foi realizado, falta a liberação do adm.",
  admin_home_status_desc_pending_approval: "O cliente ainda não aprovou o orçamento.",
  admin_home_status_desc_approved_maintenance: "O cliente aprovou e deve ter enviado a ordem de compra.",
  admin_home_status_desc_waiting_inspection: "Realize a inspeção Final e upload do laudo do equipamento.",
  admin_home_status_desc_waiting_nf: "Realize o faturamento do cliente.",
  admin_home_status_desc_ready_pickup: "O equipamento está pronto, aguarda o cliente retirar para dar baixa.",
  admin_home_last_update_text: "Última atualização: ",
  admin_home_table_header_created: "Criado",
  admin_home_table_header_type: "Tipo",
  admin_home_table_header_code: "Código",
  admin_home_table_header_cnpj: "CNPJ",
  admin_home_table_header_client: "Cliente",
  admin_home_table_header_value: "Valor R$",
  admin_home_table_footer_total: "TOTAL",
  admin_home_btn_register: "Cadastrar",
  admin_home_btn_register_client: "Cadastrar Cliente",
  admin_home_btn_search: "Pesquisar",
  admin_home_search_cnpj_nota_label: "Busca por CNPJ ou Numero da Nota",
  admin_home_search_cnpj_nota_placeholder: "Busca por CNPJ ou Numero da Nota",
  admin_home_search_note_pending_msg: "Busca por CNPJ ativa. Busca por nota aguardando atualizacao do backend na Home.",
  admin_home_btn_search_equipment: "Buscar Equipamento",
  admin_home_btn_clients: "Clientes",
  admin_home_btn_reports: "Relatórios",
  admin_home_panel_title_phases: "Fases da Operação",
  admin_home_panel_label_responsible: "Responsável:",
  admin_home_panel_label_admin: "Comercial",
  admin_home_panel_label_client: "Cliente",
  admin_home_panel_label_workshop: "Oficina",
  admin_quotations_swal_attention_title: "Atenção",
  admin_quotations_swal_new_appointment_warning: "Ao prosseguir, você vai gerar um novo apontamento sem vínculo com nenhuma estimativa. Tem certeza que deseja continuar? (para gerar um apontamento vinculado, faça isso a partir dos detalhes da estimativa)",
  admin_quotations_swal_confirm_continue: "Sim, continuar",
  admin_quotations_swal_cancel: "Cancelar",
  admin_quotations_swal_new_appointment_title: "Novo Apontamento",
  admin_quotations_swal_creating_appointment_text: "Criando novo apontamento...",
  admin_quotations_loading_text: "Carregando...",
  admin_quotations_page_title: "Cotações",
  admin_quotations_label_client: "Cliente: ",
  admin_quotations_btn_create_appointment: "Criar Apontamento",
  admin_quotations_btn_equipments: "Equipamentos",
  admin_quotations_section_title_pending: "Pendente Comigo",
  admin_quotations_empty_message_pending: "Nenhum registro pendente",
  admin_quotations_section_title_in_progress: "Em Andamento",
  admin_quotations_empty_message_in_progress: "Nenhum registro em andamento",
  admin_quotations_section_title_finished: "Finalizados",
  admin_quotations_empty_message_finished: "Nenhum registro finalizado",
  admin_quote_swal_attention_title: "Atenção",
  admin_quote_swal_equipment_already_added: "Equipamento já adicionado ao orçamento",
  admin_quote_swal_remove_equipment_title: "Remover equipamento?",
  admin_quote_swal_yes: "Sim",
  admin_quote_swal_no: "Não",
  admin_quote_swal_no_service_linked: "Este equipamento não possui serviço vinculado",
  admin_quote_swal_error_title: "Erro",
  admin_quote_swal_service_not_found: "Serviço não encontrado",
  admin_quote_swal_remove_item_title: "Remover item?",
  admin_quote_swal_success_title: "Sucesso",
  admin_quote_swal_attachment_sent: "Anexo enviado com sucesso!",
  admin_quote_swal_add_nf_title: "Adicionar Nota Fiscal",
  admin_quote_swal_nf_name_placeholder: "Nome da NF",
  admin_quote_swal_select_file: "Selecionar Arquivo",
  admin_quote_swal_cancel: "Cancelar",
  admin_quote_swal_validation_nf: "Preencha o nome e a data da NF",
  admin_quote_swal_nf_sent: "Nota Fiscal enviada!",
  admin_quote_swal_remove_attachment_title: "Remover anexo?",
  admin_quote_swal_action_undone_text: "Esta ação não poderá ser desfeita.",
  admin_quote_swal_confirm_remove: "Sim, remover",
  admin_quote_swal_attachment_removed: "Anexo removido com sucesso",
  admin_quote_swal_remove_nf_title: "Remover NF?",
  admin_quote_swal_nf_removed: "Nota fiscal removida com sucesso",
  admin_quote_swal_no_equipments_error: "Adicione pelo menos um equipamento ao orçamento",
  admin_quote_swal_generate_quote_title: "Gerar Orçamento",
  admin_quote_swal_generate_quote_text: "Com isso será gerado um orçamento para aprovação administrativa.\n\nTenha certeza de ter incluído todas as peças e procedimentos do serviço.\n\nDeseja prosseguir?",
  admin_quote_swal_generate_quote_confirm: "Sim, gerar orçamento",
  admin_quote_swal_quote_saved_success: "Orçamento salvo com sucesso!",
  admin_quote_swal_save_error: "Não foi possível salvar o orçamento",
  admin_search_placeholder_company_cnpj: "empresa ou cnpj",
  admin_search_placeholder_quotation_num: "nº cotação",
  admin_search_msg_initial: "🔎 Informe o que deseja buscar",
  admin_search_title_companies_found: "Empresas Encontradas",
  admin_search_msg_no_companies: "Nenhuma empresa encontrada",
  admin_search_title_quotations_found: "Cotações Encontradas",
  admin_search_msg_no_quotations: "Nenhuma cotação encontrada",
  admin_search_label_company: "Empresa:",
  admin_search_label_email: "Email:",
  admin_search_label_phone: "Fone:",
  admin_search_label_cnpj: "CNPJ:",
  admin_search_label_doc_num: "Núm.Doc:",
  admin_search_label_type: "Tipo:",
  admin_search_label_date: "Data:",
  admin_search_btn_view_equipments: "Ver Equipamentos",
  admin_search_btn_view: "Visualizar",
  admin_shipment_title_main: "📦 Orientações de Envio",
  admin_shipment_title_order_data: "Dados do Pedido",
  admin_shipment_title_sender: "Remetente",
  admin_shipment_title_shipping_address: "Endereço de Envio",
  admin_shipment_title_general_instructions: "Orientações Gerais",
  admin_shipment_msg_important_print: "Importante: Imprima este documento e anexe junto ao equipamento. Caso não consiga imprimir, escreva o número do pedido e seu CNPJ na embalagem de forma visível.",
  admin_shipment_label_estimate_num: "Estimativa nº: ",
  admin_shipment_label_cnpj: "CNPJ: ",
  admin_shipment_label_client: "Cliente:",
  admin_shipment_label_company: "Empresa:",
  admin_shipment_label_phone: "Telefone:",
  admin_shipment_label_email: "E-mail:",
  admin_shipment_address_company_name: "Bepi Service",
  admin_shipment_address_street: "Estrada Velha Guarulhos São Miguel, 5135",
  admin_shipment_address_city_zip: "Jardim Arapongas, Guarulhos - SP, 07210-250",
  admin_shipment_instruction_1: "Embale os equipamentos de forma segura para evitar avarias.",
  admin_shipment_instruction_2: "Inclua todos os acessórios obrigatórios para o serviço solicitado.",
  admin_shipment_instruction_3: "Identifique cada item se houver mais de um por embalagem.",
  admin_shipment_instruction_4: "Envie apenas equipamentos aprovados. Recusados não devem ser remetidos.",
  admin_shipment_instruction_5: "Não cobramos coleta. O envio é por conta do cliente.",
  admin_shipment_instruction_6: "NF de remessa deve estar correta. Em caso de erro, o retorno será feito via frete FOB.",
  admin_shipment_msg_warning_nf: "⚠️ Se a nota fiscal for emitida de forma incorreta, o equipamento será devolvido por frete FOB.",
  admin_shipment_msg_warning_missing_data: "💡 A falta do número do pedido ou do CNPJ pode atrasar o início do seu atendimento.",
  admin_shipment_footer_technical_service: "BEPI SERVICE - Atendimento técnico",
  admin_shipment_footer_whatsapp: "Em caso de dúvidas, entre em contato pelo WhatsApp: (11) 91234-5678",
  admin_shipment_btn_back_home: "Voltar para Home",
  admin_shipment_btn_print: "Imprimir Instruções",
  admin_breadcrumb_quotations: "Cotações",
  admin_breadcrumb_quote: "Orçamento",
  admin_breadcrumb_estimate_respond: "Resposta da estimativa",
  admin_breadcrumb_search: "Pesquisar",
  admin_breadcrumb_add_equipment: "Adicionar equipamento",
  admin_breadcrumb_shipment: "Instruções de envio",
  admin_home_card_label_sent: "Enviado",
  admin_home_status_desc_sent: "O material foi enviado e nao esta mais na oficina aguardando retirada. Processo encerrado.",
  admin_home_table_header_actions: "Acoes",
  admin_home_mark_sent_btn: "Marcar como Enviado",
  admin_home_mark_sent_confirm_title: "Confirmar",
  admin_home_mark_sent_confirm_text: "Deseja avancar este item para Enviado?",
  admin_home_mark_sent_success: "Status atualizado para Enviado.",
  admin_home_mark_sent_error: "Nao foi possivel atualizar para Enviado.",
  admin_home_card_label_authorize_maintenance: "Autorizar\nManutenção",
  admin_home_status_desc_authorize_maintenance: "Validar se o cliente enviou todas as informacoes necessarias para iniciar a manutencao.",
  admin_home_authorize_maintenance_btn: "Autorizar Manutencao",
  admin_home_authorize_maintenance_confirm_title: "Confirmar",
  admin_home_authorize_maintenance_confirm_text: "Deseja avancar este item para Autorizar Manutencao?",
  admin_home_authorize_maintenance_success: "Status atualizado para Autorizar Manutencao.",
  admin_home_authorize_maintenance_error: "Nao foi possivel atualizar para Autorizar Manutencao.",
  admin_home_approve_maintenance_btn: "Aprovar para Manutencao",
  admin_home_approve_maintenance_confirm_title: "Confirmar",
  admin_home_approve_maintenance_confirm_text: "Deseja avancar este item para Aprovado para Manutencao?",
  admin_home_approve_maintenance_success: "Status atualizado para Aprovado para Manutencao.",
  admin_home_approve_maintenance_error: "Nao foi possivel atualizar para Aprovado para Manutencao.",
  admin_home_card_label_finalized: "Finalizado",
  admin_home_status_desc_finalized: "Fluxo finalizado manualmente pelo time comercial.",
  admin_details_finalize_flow_btn: "Finalizar Operação",
  admin_details_finalize_flow_confirm_title: "Confirmar",
  admin_details_finalize_flow_confirm_text: "Deseja finalizar o fluxo desta cotação?",
  admin_details_finalize_flow_success: "Fluxo finalizado com sucesso.",
  admin_details_finalize_flow_error: "Não foi possível finalizar o fluxo.",
}
